import React from 'react';

import { useServices } from 'hooks/useServices';
import { useAsyncBoundary } from 'utils/asyncBoundary/asyncBoundaryHooks';
import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useAppState } from 'hooks/useAppState';
import { useRouteMatch } from 'react-router';

export const useProdStackManagerDataProcess = () => {
  const { invalidatedCacheFlags } = useAppState();

  const {
    params: { orderId },
  } = useRouteMatch<{ orderId: string }>();

  const { injectPromise } = useAsyncBoundary();

  const dispatch = useAppDispatcher();

  const { getProdStackManagerData } = useServices();

  React.useLayoutEffect(() => {
    if (invalidatedCacheFlags.prodStackManagerData) {
      injectPromise(
        getProdStackManagerData({ orderId }).then((data) => {
          dispatch({
            name: 'ProdStackManager__DataRecieved',
            data,
          });
        })
      );
    }
  }, [
    dispatch,
    getProdStackManagerData,
    injectPromise,
    invalidatedCacheFlags.prodStackManagerData,
    orderId,
  ]);
};
